import { ICustomText } from 'projects/shared/lib/interfaces/web-text/web-text.interface';
import { ECustomTextType } from 'projects/shared/lib/services/INTEGRA_Shop_Client';

export class CustomText implements ICustomText {
  public type: ECustomTextType;
  public group: string;
  public name: string;

  constructor(type: ECustomTextType, group: string, name: string) {
    this.type = type;
    this.group = group;
    this.name = name;
  }

}
